import * as React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";
import LoadingSpinner from "../LoadingSpinner";

interface Props {
  onClick?: (props?: any) => void;
  disabled?: boolean;
  color?: string;
  icon?: React.ReactNode;
  type?: "button" | "submit" | "reset";
  loading?: boolean;
  size?: "small" | "medium" | "large";
  tabIndex?: number;
  ariaLabel?: string;
}

const ButtonContainer = styled.button<{
  color: string;
  disabled?: boolean;
  size: "small" | "medium" | "large";
}>`
  background-color: ${(props) => props.color};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border: none;
  width: ${(props) =>
    props.size === "small"
      ? "24px"
      : props.size === "medium"
        ? "32px"
        : "36px"};
  height: ${(props) =>
    props.size === "small"
      ? "24px"
      : props.size === "medium"
        ? "32px"
        : "36px"};

  flex-shrink: 0;

  &:hover {
    filter: ${(props) => !props.disabled && "opacity(0.6)"};
    box-shadow: ${(props) =>
      !props.disabled && "0px 4px 6px rgba(0, 0, 0, 0.1)"};
  }

  &:active {
    filter: opacity(1);
    box-shadow: none;
  }

  & > svg {
    flex-shrink: 0;
  }

  &:disabled {
    background-color: ${() => theme.colors.disabled};
    color: ${() => theme.colors.white};

    svg,
    svg * {
      stroke: ${() => theme.colors.white};
    }
  }
`;

const IconButton: React.FC<Props> = ({
  onClick,
  disabled,
  color = theme.colors.grey05,
  icon,
  type,
  loading,
  size = "large",
  tabIndex,
  ariaLabel,
}) => {
  return (
    <ButtonContainer
      color={color}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      size={size}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      {loading ? <LoadingSpinner /> : icon}
    </ButtonContainer>
  );
};

export default IconButton;
